module.exports = __webpack_public_path__ + "coins.97a67dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/AdminRegistration/coins.png
// module id = 3126
// module chunks = 0